module.exports = "//public.zight.com/packs/media/images/thumbnail-1870cc66cab60ffce7bad36ebbcc1b10.png";